import { Component, OnInit } from '@angular/core';

import { servicosModuleName } from "../shared/data.service";
import { Servico } from "../shared/servico.model";
import { ServicoApiService } from "../shared/servico-api.service";
import { ServicoNavigationService } from "../shared/servico-navigation.service";
import { UtilService } from "../../../shared/services/util.service";
import { ManutencaoService} from "../../shared/manutencao.service";
import { manutencoesModuleName } from "../../shared/data.service";
import { configuracaoModuleName } from "../../../shared/services/data.service";

@Component({
    template: require('./servico-list.component.html'),
    styles: [require('./servico-list.component.css')]
})
export class ServicoListComponent implements OnInit {
    list: Servico[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    servicosModuleName: any = servicosModuleName;
    configuracaoModule: any = configuracaoModuleName;
    module: any = manutencoesModuleName;

    constructor(
        private _servicosApiService: ServicoApiService,
        private _servicoNavigationService: ServicoNavigationService,
        private _utilService: UtilService,
        private _manutencaoService: ManutencaoService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickNew() {
        this._servicoNavigationService.goToNew();
    }

    clickEdit(item: Servico) {
        this._servicoNavigationService.goToEdit(item.id);
    }

    clickGoToConfig() {
        this._manutencaoService.goToSetting();
    }

    clickDelete(item: Servico) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                Response.forEach(function(item: any) {
                    if (!item.Materiais) {
                        item.Materiais = [];
                    }
                });

                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._servicosApiService.onGetWithMateriais(onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._servicosApiService.onDelete(item.id, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/servico-list/servico-list.component.ts
 **/